var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEyeClosed = function SvgEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.342 12.782-1.931-.518.787-2.939a10.988 10.988 0 0 1-3.237-1.872L1.808 9.607.393 8.192l2.154-2.153A10.957 10.957 0 0 1 .176.969L2.144.61C2.903 4.812 6.579 8 11 8c4.42 0 8.097-3.188 8.856-7.39l1.968.358a10.957 10.957 0 0 1-2.37 5.071l2.153 2.153-1.415 1.415-2.153-2.154a10.987 10.987 0 0 1-3.237 1.872l.787 2.94-1.931.517-.788-2.94a11.07 11.07 0 0 1-3.74 0l-.788 2.94Z",
    fill: "currentColor"
  })));
};

export default SvgEyeClosed;